import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button, Modal, ModalBody } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Checkbox, TextareaAutosize, TextField } from "@mui/material";

import { format } from "date-fns";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const SysAdminViewDamageDeviceDetails = ({ history, match }) => {
  const [dap_device, setDevice] = useState({
    deviceName: "",
    deviceLabel: "",
    deviceType: "",
    deviceVersion: "",
    accessToken: "",
    deviceLon: "",
  });

  // const [deviceName, setDeviceName] = useState("")
  // const [deviceLabel, setDeviceLabel] = useState("")
  // const [deviceType, setDeviceType] = useState("")
  // const [deviceVersion, setDeviceVersion] = useState("")

  const [dap_customer, setCustomer] = useState({
    userFirstName: "",
    userLastName: "",
    industry: "",
    city: "",
  });
  const [dap_partner, setPartner] = useState({
    userFirstName: "",
    userLastName: "",
  });

  const [show, setShow] = useState(false);

  const { SearchBar } = Search;

  const [choosePartner, setChoosePartner] = useState({});
  const [goBackLink, setGoBackLink] = useState("");
  const [allPartner, setAllPartner] = useState([]);
  const [location, setLocation] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const [journeyData, setJourneyData] = useState([]);

  let location_array = [];
  location_array = [
    {
      locationName: "Healthcare",
      locationId: 1,
    },
    {
      locationName: "Education",
      locationId: 2,
    },
    {
      locationName: "Manufacturing",
      locationId: 3,
    },
    {
      locationName: "Hospitality",
      locationId: 4,
    },
    {
      locationName: "Corporate",
      locationId: 5,
    },
    {
      locationName: "None",
      locationId: 10,
    },
  ];

  useEffect(() => {
    let id = match.params.id;
    //  console.log(id);getLead(id);

    if (localStorage.getItem("isLeadExecutive")) {
      setGoBackLink("/devices");
    } else {
      setGoBackLink("/devices");
    }

    console.log(id);

    axios
      .get(environment.dap_url + "dapDevice/viewAsset?id=" + id)
      .then((res) => {
        console.log(res.data[0].customer_details);
        if (res.data) {
          setDevice(res.data[0]);
          setAccessToken(res.data[0].accessToken);
          setLocation(res.data[0].deviceLon);
          if (res.data[0].customer_details.length == 1) {
            // if(res.data[0].customer_details.length==1){
            setCustomer(res.data[0].customer_details[0]);
            // setLocation(res.data[0].deviceLon)
            // }
          }
          if (res.data[0].TenantDetails.length == 1) {
            setPartner(res.data[0].TenantDetails[0]);
            setChoosePartner({
              id: res.data[0].TenantDetails[0].id,
              label: res.data[0].TenantDetails[0].label,
              value: res.data[0].TenantDetails[0].value,
            });
          }
          axios
            .get(
              environment.dap_url +
                "dapDevice/deviceJourney?deviceLabel=" +
                res.data[0].deviceLabel
            )
            .then((resDevice) => {
              console.log("hii");
              // console.log(resDevice.data[0])
              let arr = [];
              for (let i = 0; i < resDevice.data.length; i++) {
                // arr[i].id=i;
                resDevice.data[i].id = i;
              }

              console.log(resDevice.data);
              setJourneyData(resDevice.data);
            });
        }
      });

    axios
      .get(environment.dap_url + `partnerApi/getAll`)
      .then((res) => {
        console.log(res.data);
        setAllPartner(res.data);
      })
      .catch(function (error) {
        window.alert(error.message);
      });
  }, []);

  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        let dateArr = dataField.split("T")[0].split("-");
        return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
      },
    },
    {
      dataField: "statusText",
      text: "Status",
      sort: true,
    },
    {
      dataField: "id",
      text: "Customer",
      sort: true,
      formatter: (dataField) => {
        // return dataField;
        if (journeyData[dataField].customer_details.length == 1) {
          return (
            journeyData[dataField].customer_details[0].userFirstName +
            " " +
            journeyData[dataField].customer_details[0].userLastName
          );
        } else {
          return "";
        }
      },
    },
    {
      dataField: "id",
      text: "City",
      sort: true,
      formatter: (dataField) => {
        if (journeyData[dataField].customer_details.length == 1) {
          return journeyData[dataField].customer_details[0].city;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "deviceAlias",
      text: "Device Installed Place",
      sort: true,
      // formatter:(dataField)=>{
      //   if(journeyData[dataField].customer_details.length==1){
      //     return journeyData[dataField].customer_details[0].city
      //   }else{
      //     return "";
      //   }
      // }
    },
    {
      dataField: "lat",
      text: "Latitude",
      sort: true,
    },
    {
      dataField: "long",
      text: "Longitude",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  const handleModal = (e, target) => {
    handleShow();
  };
  const handleSubmit = (e) => {
    console.log(choosePartner.value + " - " + location + " - " + accessToken);
    axios
      .put(
        environment.dap_url + "dapDevice/updateAsset?id=" + match.params.id,
        {
          tenantId: choosePartner.value,
          accessToken: accessToken,
          lon: location,
        }
      )
      .then((res) => {
        if (res.status == 200) {
          MySwal.fire({
            title: "Update Successfully",
            icon: "success",
            type: "success",
          }).then((result) => {
            handleClose();
            window.location.reload();
          });
        }
      });
  };
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const setPartnerEdit = (e) => {
    console.log(e);
    setChoosePartner({
      id: e.id,
      label: e.label,
      value: e.value,
    });
  };
  const setLocationHandler = (loc) => {
    setLocation(loc);
  };

  return (
    <div>
      <div className="container-fluid">
        <NavbarNew />
        <div class="col-md-12">
          <Link to={goBackLink} className="btn btn-light my-3">
            Go Back
          </Link>
        </div>
      </div>

      <div className="container-fluid">
        <h4 className="card-title">Asset Details</h4>
        <div className="row">
          <div className="col-6">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th>Asset Label</th>
                  <td>{dap_device.deviceLabel}</td>
                </tr>
                <tr>
                  <th>Asset Category</th>
                  <td>{dap_device.deviceType}</td>
                </tr>
                <tr>
                  <th>Asset Model</th>
                  <td>{dap_device.deviceVersion}</td>
                </tr>
                <tr>
                  <th>Asset token</th>
                  <td>{dap_device.accessToken}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-6">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th>Partner</th>
                  <td>
                    {dap_partner.userFirstName + " " + dap_partner.userLastName}
                  </td>
                </tr>
                <tr>
                  <th>Customer</th>
                  <td>
                    {dap_customer.userFirstName +
                      " " +
                      dap_customer.userLastName}
                  </td>
                </tr>
                <tr>
                  <th>Industry</th>
                  <td>{dap_customer.industry}</td>
                </tr>
                <tr>
                  <th>City</th>
                  <td>{dap_customer.city}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h4 className="card-title">Asset History</h4>
        <ToolkitProvider
          keyField="id"
          bootstrap4
          data={journeyData}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={paginationFactory()}
                {...props.baseProps}
                wrapperClasses="table-responsive"
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6">
              <label>Select Partner</label>
              <Select
                options={allPartner.map((element) => ({
                  id: element._id,
                  value: element.tenantId,
                  label: element.userFirstName + " " + element.userLastName,
                }))}
                // value={{
                //   id: "",
                //   label: postcountry,
                //   value: postcountry,
                // }}
                value={choosePartner}
                onChange={(e) => setPartnerEdit(e)}
                placeholder="Country"
              />
            </div>
            <div className="col-6">
              <label>Select Industry</label>
              <Select
                options={location_array.map((element) => ({
                  id: element.locationId,
                  value: element.locationName,
                  label: element.locationName,
                }))}
                // value={{location}}
                onChange={(e) => setLocationHandler(e.value)}
                // defaultValue={dap_deviceList[0].name}
                defaultValue="hi there"
              />
              {/* <TextField
                        label="Location"
                        name="location"
                        type="text"
                        value={location}
                        onChange={(e)=>setLocation(e.target.value)}
                        required/> */}
            </div>
          </div>
          <div className="row m-4">
            <div className="col-12">
              <TextField
                label="Access Token"
                name="accessToken"
                type="text"
                value={accessToken}
                onChange={(e) => setAccessToken(e.target.value)}
                required
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          `
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SysAdminViewDamageDeviceDetails;
